import '@babel/polyfill'
import Vue from 'vue'
import Main from './main.vue'
import router from './router'
import store from './store/'
import './plugins'
import './ui'
import './app'
import './assets/scss/index.scss'

// Vue APP
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(Main)
}).$mount('#app')
